export enum DealTypes {
  CASH = 'cash',
  FINANCE = 'finance',
  LEASE = 'lease',
}
